import React from 'react'
import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { updateUserNotificationPreference } from '../api/queries/update-user-notification-preference'

export interface ShowFirstTimeNotificationProps {
  isFreemium: boolean
  showFirstTimeNotification: boolean
  enabled: boolean
  setNewUserOnboardingPreferenceCallback?: (unknown) => void
  onError?: (error: Error) => void
}

const handleError = (error) => {
  console.error(error)
}

export function useShowFirstTimeNotification({
  isFreemium,
  showFirstTimeNotification,
  enabled,
  setNewUserOnboardingPreferenceCallback,
  onError = handleError
}: ShowFirstTimeNotificationProps): boolean {
  const { mutate } = useContrastMutation(updateUserNotificationPreference)
  const onSuccess = React.useCallback(() => {
    if (
      setNewUserOnboardingPreferenceCallback &&
      typeof setNewUserOnboardingPreferenceCallback === 'function'
    ) {
      setNewUserOnboardingPreferenceCallback(false)
    }
  }, [setNewUserOnboardingPreferenceCallback])

  React.useEffect(() => {
    if (isFreemium && showFirstTimeNotification && enabled) {
      mutate(undefined, { onSuccess, onError })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFreemium, showFirstTimeNotification, enabled, mutate, onSuccess])

  React.useDebugValue(
    `showFirstTimeNotification: ${isFreemium && showFirstTimeNotification}`
  )

  return isFreemium && showFirstTimeNotification
}
